import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { onThisDay } from '../../common/api';
import { bind } from '../../common/widgetData';
import { num } from '../../common/dates';
const t = (k, p) => app.translator.trans('ernestdefoe-calendar.forum.' + k, p);

/**
 * "On this day" — popular threads from today's date in years past. Self-contained
 * POJO so it works on the stock index, a Bespoke widget, or a Page Builder block.
 * attrs: { title, count }.
 */
const OnThisDayWidget = {
  oninit(vnode) {
    const count = Math.max(1, Number((vnode.attrs || {}).count) || 6);
    bind(this, 'memories', 'onthisday:' + count, () => onThisDay(count), []);
  },
  view(vnode) {
    const a = vnode.attrs || {};
    const title = a.title || t('memories_title');
    const memories = this.memories;
    return m('.CalMemories', [m('.CalMemories-head', [m('h4.CalMemories-title', ['🕰️ ', title])]), memories === null ? m('.CalMemories-loading', m(LoadingIndicator)) : memories.length === 0 ? m('p.CalMemories-empty', t('memories_empty')) : m('ul.CalMemories-list', memories.map(mem => row(mem)))]);
  }
};
function row(mem) {
  return m('li.CalMemories-item', [m('a.CalMemories-link', {
    href: app.route('discussion', {
      id: mem.id + (mem.slug ? '-' + mem.slug : '')
    }),
    oncreate: m.route.Link
  }, mem.title), m('span.CalMemories-meta', [m('span.CalMemories-years', t('memories_years_ago', {
    years: num(mem.yearsAgo)
  })), ' · ', t('memories_replies', {
    count: num(mem.commentCount)
  })])]);
}
export default OnThisDayWidget;
flarum.reg.add('ernestdefoe-calendar', 'forum/components/OnThisDayWidget', OnThisDayWidget);